import { render, staticRenderFns } from "./TripStatsWrapper.vue?vue&type=template&id=d1cb4c00"
import script from "./TripStatsWrapper.vue?vue&type=script&lang=ts"
export * from "./TripStatsWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports